var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 py-2"},[_c('div',{staticClass:"card card-body mb-4 shadow-sm"},[_c('h4',{staticClass:"font-weight-light mb-3"},[_vm._v("DataTables")]),_c('DataTable')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }